import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const namely = defineConnector({
  identifier: "namely",
  name: "Namely",
  tagLine: "HR platform for mid-sized companies",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: () => "https://[^/]*\\.namely\\.com/.*",
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Get your Namely API token",
      items: [
        {
          kind: "markdown",
          content: `1. In Namely, go to **API** in your company settings
2. Generate a permanent access token
3. Copy the token`,
        },
      ],
    },
    {
      title: "Enter your Namely details",
      items: [
        {
          kind: "hostname",
          label: "Domain",
          required: true,
          placeholder: "acme.namely.com",
          target: { kind: "configuration", field: "domain" },
          helperText: "Your Namely domain (e.g., acme.namely.com)",
        },
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/api/v1/profiles/me`,
  },
  publicEnvVars: ({ domain }) => ({
    NAMELY_URL: domain ? `https://${domain}` : "",
  }),
});
